// Public assets are resolved by the browser, as on the original Home screen.
export const homeBackgroundStyle = Object.freeze({
  backgroundImage: "linear-gradient(135deg, rgba(8, 20, 44, 0.75) 0%, rgba(13, 45, 98, 0.62) 45%, rgba(20, 83, 163, 0.55) 100%), image-set(url('/Home-Background.webp') type('image/webp'), url('/Home-Background.jpg') type('image/jpeg'))"
})
